import React from "react";

export default function Settings() {
  return <div>Coming soon!</div>;
}

// import {
//   Container,
//   Box,
//   Button,
//   Alert,
//   LinearProgress,
//   Snackbar,
// } from "@mui/material";

// // functions
// import { useState } from "react";
// import { useAuthContext } from "../../hooks/useAuthContext";
// import { useUserInit } from "../../hooks/useUserInit";
// import { useLogout } from "../../hooks/useLogout";
// import { useFirestore } from "../../hooks/useFirestore";

// //Components
// import UserForm from "../../components/UserForm";

// export default function Settings() {
//   const { user: authUser } = useAuthContext();
//   const { user, userHostel, isLoading, error } = useUserInit(authUser);

//   const { logout, logoutIsPending } = useLogout();

//   const { updateDocument, response } = useFirestore("users");
//   const [updateError, setUpdateError] = useState(null);
//   const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);

//   const save = async (value) => {
//     console.log(value);
//     setIsLoadingUpdate(true);
//     // await updateDocument(user.id, {
//     //   [`hostels.${hostelId}.foodPreference`]: foodPreference,
//     // });
//     setIsLoadingUpdate(false);
//     if (response.error) {
//       setUpdateError(response.error);
//     }
//     setSnackbarOpen(true);
//   };

//   const [snackbarOpen, setSnackbarOpen] = useState(false);

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") {
//       return;
//     }

//     setSnackbarOpen(false);
//   };

//   return (
//     <Container
//       maxWidth="lg"
//       sx={{
//         minHeight: { xs: "80vh", sm: "80vh", md: "79.8vh" },
//         marginTop: "10px",
//         // marginBottom: "10px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <Box>
//         {isLoading && (
//           <LinearProgress
//             sx={{
//               position: "absolute",
//               top: { xs: "58px", sm: "64px", md: "64px" },
//               left: 0,
//               right: 0,
//               zIndex: 1,
//             }}
//           />
//         )}
//         {error && <Alert severity="error">{error}</Alert>}

//         {error === "Not registered yet" && (
//           <>
//             <Box height={18} />

//             <Button
//               variant="contained"
//               onClick={logout}
//               disabled={logoutIsPending}
//               sx={{
//                 margin: "0 auto",
//                 display: "block",
//                 // width: "100%",
//               }}
//             >
//               Register now
//             </Button>
//           </>
//         )}

//         {!isLoading && !error && user && userHostel && (
//           <UserForm user={user} type={userHostel.type} onSubmit={save} />
//         )}
//       </Box>
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={handleSnackbarClose}
//       >
//         <Alert
//           onClose={handleSnackbarClose}
//           severity={updateError ? "error" : "success"}
//           sx={{ width: "100%" }}
//         >
//           {updateError ? updateError : "Successfully updated!"}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// }
